const API_URL = "https://flask-service.cpqoh27qdk7va.us-east-1.cs.amazonlightsail.com/"
//const API_URL = "http://127.0.0.1:5000/"


export { API_URL };